import React, { useEffect, useState } from 'react';

import Countdown from 'react-countdown';
import { useSelector } from 'react-redux';

import { IState } from 'store';
import { IConfigApplicationProps } from 'store/modules/config';

import * as S from './styles';

interface ITimerProps {
  containerClassName: string;
}

const Timer = ({ containerClassName }: ITimerProps) => {
  const { ultraDescontao } = useSelector<IState, IConfigApplicationProps>(
    state => state.config.config,
  );

  const [windowWidth, setWindowWidth] = useState('web');

  useEffect(() => {
    const getWidth = () => {
      if (window.innerWidth > 768) {
        setWindowWidth('web');
        setImgBackground(ultraDescontao?.cronometroImagemUrl);
      } else {
        setWindowWidth('mobile');
        setImgBackground(ultraDescontao?.cronometroImagemMobileUrl);
      }
    };

    getWidth();

    // eslint-disable-next-line no-restricted-globals
    onresize = () => {
      getWidth();
    };
  }, [ultraDescontao]);

  const [imgBackground, setImgBackground] = useState('');

  const dateFim = new Date(ultraDescontao?.cronometroFim);
  const cronometroValid = dateFim > new Date();

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (!completed) {
      return (
        <div className="timer-countdown">
          {days > 0 && (
            <div className="timer-days">
              <strong>{days}</strong>
              <span>{days > 1 ? 'DIAS' : 'DIA'}</span>
            </div>
          )}
          <div className="timer-hours">
            <strong>{hours < 10 ? '0' + hours : hours}</strong>
            <span>{hours !== 1 ? 'HORAS' : 'HORA'}</span>
          </div>
          <div className="timer-separator">
            <strong>:</strong>
          </div>
          <div className="timer-minutes">
            <strong>{minutes < 10 ? '0' + minutes : minutes}</strong>
            <span>MIN</span>
          </div>
          <div className="timer-separator">
            <strong>:</strong>
          </div>
          <div className="timer-seconds">
            <strong>{seconds < 10 ? '0' + seconds : seconds}</strong>
            <span>SEG</span>
          </div>
        </div>
      );
    }
    return <></>;
  };

  return (
    <>
      {ultraDescontao?.estaVigente &&
        ultraDescontao?.cronometroAtivo &&
        cronometroValid && (
          <S.Container
            className={`timer-container${
              containerClassName ? ` ${containerClassName}` : ''
            }`}
            id={`timer${containerClassName ? ` ${containerClassName}` : ''}`}
          >
            <a
              href={ultraDescontao?.cronometroUrl}
              className="timer-content"
              style={{
                backgroundImage: `url("${imgBackground}")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                color: `#${ultraDescontao.corTexto}`,
              }}
            >
              {windowWidth === 'web' ? (
                <>
                  {!!ultraDescontao.iconeCronometroUrl && (
                    <img
                      src={ultraDescontao.iconeCronometroUrl}
                      alt="Selo Ultradescontão"
                      className="timer-selo"
                    />
                  )}
                </>
              ) : (
                <>
                  {!!ultraDescontao.iconeMobileCronometroUrl && (
                    <img
                      src={ultraDescontao.iconeMobileCronometroUrl}
                      alt="Selo Ultradescontão"
                      className="timer-selo"
                    />
                  )}
                </>
              )}

              <div>
                <div
                  className="timer-text item1"
                  style={{
                    color: `#${ultraDescontao.corTexto}`,
                  }}
                >
                  APROVEITE PARA COMPRAR
                  <span
                    style={{
                      color: `#${ultraDescontao.corTextoBarato}`,
                    }}
                  >
                    {' '}
                    + BARATO
                  </span>
                </div>

                <h3 className="timer-text item2">
                  {ultraDescontao.cronometroCallToAction}
                </h3>

                <div
                  className="timer-box"
                  style={{
                    color: `#${ultraDescontao.corCronometro}`,
                  }}
                >
                  <Countdown date={dateFim} renderer={renderer} />
                </div>
              </div>
            </a>
          </S.Container>
        )}
    </>
  );
};

export default Timer;
